import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FilterBase } from './filter-base';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { NgClass } from '@angular/common';
@Component({
    selector: 'nova-text-filter',
    template: ` <mat-form-field>
        <input
            matInput
            type="text"
            #filterText
            [placeholder]="title"
            [value]="getCurrentValue()"
            (blur)="setFilter(filterText.value)"
            (change)="setFilter(filterText.value)"
            [ngClass]="uniqueFilterClass" />
    </mat-form-field>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, NgClass]
})
export class TextFilterComponent extends FilterBase {
    @Input() title: string;
    @Input() public uniqueFilterClass: string;

    setFilter(value: string) {
        if (value && value.length) {
            this.filterService.filter({
                filters: [
                    {
                        field: this.field,
                        operator: 'startswith',
                        value: value
                    }
                ],
                logic: 'and'
            });
        }
    }
}
